import { API_ENDPOINTS } from '@/config/api'
import type { IUserInfo } from '@/types/home'
import { invokeSafe } from '@kiti/js-bridge'
import { reportHttp } from '@/utils/http/request'

/**
 * 接口示例，走端代理
 */
export async function postKitiReport(params: Record<string, any>) {
  return reportHttp.post<ApiResponse<null>>(API_ENDPOINTS.REPORT.H5_REPORT, params)
}

export async function fetUserInfo() {
  return invokeSafe<ApiResponse<IUserInfo>>('getRequest', {
    path: 'kiti-chat/outer/customer/acquire-customer'
  })
}
